export const isSentFlag = (value) =>
  value === true || String(value).toLowerCase() === "true";

export const normalizeApprovalStatus = (status) =>
  String(status || "").toLowerCase();

export const getRequestStatusKey = (item) => {
  if (isSentFlag(item?.is_sent)) return "sent";
  const normalized = normalizeApprovalStatus(item?.request_status);
  if (normalized === "sent") return "sent";
  return normalized;
};

export const getRequestStatusLabel = (statusKey) => {
  const normalized = normalizeApprovalStatus(statusKey);
  if (normalized === "sent") return "Sent";
  if (normalized === "approved") return "Approved";
  if (normalized === "pending") return "Pending";
  if (normalized === "declined" || normalized === "decline") return "Declined";
  return statusKey || "";
};

export const getRequestStatusClassName = (statusKey, prefix = "approval") => {
  const normalized = normalizeApprovalStatus(statusKey);
  if (prefix === "messages-approval") {
    return `messages-approval-status ${normalized}`;
  }
  return `approved-group-status ${normalized}`;
};
